import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { CalendarDays, CalendarClock, CalendarOff } from "lucide-react";
import CalendarBoard from "@/components/schedule/CalendarBoard";
import Availability from "@/components/schedule/Availability";
import LeaveRequests from "@/components/schedule/LeaveRequests";

export default function Schedule() {
  const { can } = useAuth();
  const { t } = useI18n();
  const showAvail = can("availability.view");
  const showLeave = can("leave.view");

  return (
    <div className="space-y-2" data-testid="schedule-page">
      <Tabs defaultValue="calendar" className="space-y-2">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <TabsList data-testid="schedule-tabs" className="h-8">
            <TabsTrigger value="calendar" data-testid="tab-calendar" className="text-xs py-1"><CalendarDays className="h-3.5 w-3.5 mr-1" />{t("cal.tab.calendar", "Calendar")}</TabsTrigger>
            {showAvail && <TabsTrigger value="availability" data-testid="tab-availability" className="text-xs py-1"><CalendarClock className="h-3.5 w-3.5 mr-1" />{t("cal.tab.availability", "Availability")}</TabsTrigger>}
            {showLeave && <TabsTrigger value="leave" data-testid="tab-leave" className="text-xs py-1"><CalendarOff className="h-3.5 w-3.5 mr-1" />{t("cal.tab.leave", "Leave")}</TabsTrigger>}
          </TabsList>
          <div className="flex items-center gap-4 text-xs" data-testid="calendar-legend">
            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-teal-600 inline-block" />{t("cal.legend.shift", "Site shift · Connect")}</span>
            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm inline-block" style={{ background: "linear-gradient(90deg,#2563eb 33%,#dc2626 33% 66%,#16a34a 66%)" }} />{t("cal.legend.jobByCleaner", "Field job · cleaner's colour")}</span>
            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-gray-200 border border-gray-400 inline-block" /><span className="text-red-600 font-semibold">Unassigned</span></span>
          </div>
        </div>

        <TabsContent value="calendar" className="mt-0"><CalendarBoard /></TabsContent>
        {showAvail && <TabsContent value="availability"><Availability /></TabsContent>}
        {showLeave && <TabsContent value="leave"><LeaveRequests /></TabsContent>}
      </Tabs>
    </div>
  );
}
